import { anyPromiseTrackerTagsInProgress } from "@common/utils";
import React from "react";

export interface ISuspenseProps {
    tag: string | string[];
    delay?: number;
    waiting?: JSX.Element;
}
export const Suspense = (props: React.PropsWithChildren<ISuspenseProps>): JSX.Element => {
    const promiseInProgress = anyPromiseTrackerTagsInProgress(Array.isArray(props.tag) ? props.tag : [props.tag], props.delay);
    return promiseInProgress ? (props.waiting || <span>Loading...</span>) : <>{props.children}</>;
};
